import IconConsignerInactive from 'images/icons/menu/inactive/consigner.svg';
import IconConsignerActive from 'images/icons/menu/active/consigner.svg';
// import IconInvoiceInactive from 'images/icons/menu/inactive/invoice.svg';
// import IconInvoiceActive from 'images/icons/menu/active/invoice.svg';
import IconOperationsInactive from 'images/icons/menu/inactive/operations.svg';
import IconOperationsActive from 'images/icons/menu/active/operations.svg';
import IconOperatorInactive from 'images/icons/menu/inactive/operator.svg';
import IconOperatorActive from 'images/icons/menu/active/operator.svg';
import IconPlacementInactive from 'images/icons/menu/inactive/placement.svg';
import IconPlacementActive from 'images/icons/menu/active/placement.svg';
import IconPodInactive from 'images/icons/menu/inactive/pod.svg';
import IconPodActive from 'images/icons/menu/active/pod.svg';
import IconThirdPartyInactive from 'images/icons/menu/inactive/third-party.svg';
import IconThirdPartyActive from 'images/icons/menu/active/third-party.svg';
import IconCreateDemandInactive from 'images/icons/menu/inactive/create_demand.svg';
import IconCreateDemandActive from 'images/icons/menu/active/create_demand.svg';
import IconNasdaqInactive from 'images/icons/menu/inactive/pricing.svg';
import IconNasdaqActive from 'images/icons/menu/active/pricing.svg';
import CMSPanelActive from 'images/svgs/cms-panel-active.svg';
import CMSPanel from 'images/svgs/cms-panel.svg';
import SidebarShieldActive from 'images/svgs/sidebar-shield-active.svg';
import SidebarShieldInactive from 'images/svgs/sidebar-shield-inactive.svg';
import OperatorRateInfoActive from 'images/icons/menu/active/operator-info.svg';
import OperatorRateInfoInActive from 'images/icons/menu/inactive/operator-info.svg';
import ManualPlacementInactive from 'images/icons/menu/inactive/manual-placement.svg';
import ManualPlacementActive from 'images/icons/menu/active/manual-placement.svg';

import PriceChangeActive from 'images/icons/menu/active/price-config-active.svg';
import PriceChangeInactive from 'images/icons/menu/inactive/price-config-inactive.svg';
const CONSTANTS = {
  MENU_ITEMS: [
    {
      NAME: 'Consigner',
      PATH: '/portal/consigner',
      ACTIVE: IconConsignerActive,
      INACTIVE: IconConsignerInactive,
    },
    {
      NAME: 'Operator',
      PATH: '/portal/operator',
      ACTIVE: IconOperatorActive,
      INACTIVE: IconOperatorInactive,
    },
    {
      NAME: 'Lead Management',
      PATH: '/portal/lms',
      ACTIVE: IconThirdPartyActive,
      INACTIVE: IconThirdPartyInactive,
    },
    {
      NAME: 'Create Demand',
      PATH: '/portal/create-demand',
      ACTIVE: IconCreateDemandActive,
      INACTIVE: IconCreateDemandInactive,
    },
    {
      NAME: 'Ticketing',
      PATH: '/portal/ticketing',
      ACTIVE: IconPodActive,
      INACTIVE: IconPodInactive,
    },
    {
      NAME: 'Ticket Assignment',
      PATH: '/portal/ticket-assignment',
      ACTIVE: SidebarShieldActive,
      INACTIVE: SidebarShieldInactive,
    },
    // {
    //   NAME: 'Lane Rate Dashboard',
    //   PATH: '/portal/lane-rate-dashboard',
    //   ACTIVE: IconPlacementActive,
    //   INACTIVE: IconPlacementActive,
    // },
    {
      NAME: 'PTL',
      ACTIVE: IconPodActive,
      INACTIVE: IconPodInactive,
      ID: 'PTL',
      SUB_MENU: [
        {
          NAME: 'Create Demand PTL',
          PATH: '/portal/create-demand-ptl',
          ACTIVE: IconCreateDemandActive,
          INACTIVE: IconCreateDemandInactive,
        },
        {
          NAME: 'PTL Bulk MIS',
          PATH: '/portal/ptl-bulk-mis',
          ACTIVE: IconCreateDemandActive,
          INACTIVE: IconCreateDemandInactive,
        },
        {
          NAME: 'PTL Ticketing',
          PATH: '/portal/ptl-ticketing',
          ACTIVE: IconPodActive,
          INACTIVE: IconPodInactive,
        },
        {
          NAME: 'PTL Freight/Invoice Upload',
          PATH: '/portal/ptl-freight-upload',
          ACTIVE: IconPodActive,
          INACTIVE: IconPodInactive,
        },
        {
          NAME: 'PTL Tasks',
          PATH: '/portal/ptl-tasks',
          ACTIVE: IconPodActive,
          INACTIVE: IconPodInactive,
        },
        {
          NAME: 'PTL Consigner Onboard',
          PATH: '/portal/ptl-onboarding',
          ACTIVE: IconPodActive,
          INACTIVE: IconPodInactive,
        },
      ],
    },
    {
      NAME: 'Placement',
      PATH: '/portal/placement',
      ACTIVE: IconPlacementActive,
      INACTIVE: IconPlacementInactive,
    },
    {
      NAME: 'Operator Rate Info',
      PATH: '/portal/operator-rate-info',
      ACTIVE: OperatorRateInfoActive,
      INACTIVE: OperatorRateInfoInActive,
    },
    {
      NAME: 'Manual Placement',
      PATH: '/portal/manual-placement',
      ACTIVE: ManualPlacementActive,
      INACTIVE: ManualPlacementInactive,
    },
    {
      NAME: 'Operations',
      PATH: '/portal/operations',
      ACTIVE: IconOperationsActive,
      INACTIVE: IconOperationsInactive,
    },
    // {
    //   NAME: 'POD',
    //   PATH: '/portal/oldportal/pod',
    //   ACTIVE: IconPodActive,
    //   INACTIVE: IconPodInactive,
    // },
    // {
    //   NAME: 'Invoice',
    //   PATH: '/portal/oldportal/invoice',
    //   ACTIVE: IconInvoiceActive,
    //   INACTIVE: IconInvoiceInactive,
    // },
    // {
    //   NAME: 'Update Vehicle',
    //   PATH: '/portal/update-vehicle',
    //   ACTIVE: IconThirdPartyActive,
    //   INACTIVE: IconThirdPartyInactive,
    // },
    {
      NAME: 'Third Party',
      PATH: '/portal/third-party',
      ACTIVE: IconThirdPartyActive,
      INACTIVE: IconThirdPartyInactive,
    },
    {
      NAME: 'Transaction',
      PATH: '/portal/transactions',
      ACTIVE: IconNasdaqActive,
      INACTIVE: IconNasdaqInactive,
    },
    {
      NAME: 'SEO CMS',
      PATH: '/portal/cms',
      ACTIVE: CMSPanelActive,
      INACTIVE: CMSPanel,
    },
    {
      NAME: 'Issue Creation',
      PATH: '/portal/issue-creation',
      ACTIVE: CMSPanelActive,
      INACTIVE: CMSPanel,
    },
    {
      NAME: 'Permissions',
      PATH: '/portal/permissions',
      ACTIVE: SidebarShieldActive,
      INACTIVE: SidebarShieldInactive,
    },
    {
      NAME: 'PrC',
      PATH: '/portal/pricing-config',
      ACTIVE: PriceChangeActive,
      INACTIVE: PriceChangeInactive,
    },
    {
      NAME: 'BASegment',
      PATH: '/portal/segment-config',
      ACTIVE: PriceChangeActive,
      INACTIVE: PriceChangeInactive,
    },
    {
      NAME: 'Bulk Upload',
      PATH: '/portal/bulk-upload',
      ACTIVE: IconCreateDemandActive,
      INACTIVE: IconCreateDemandInactive,
    },
    {
      NAME: 'Creative Upload',
      PATH: '/portal/creative-upload',
      ACTIVE: CMSPanelActive,
      INACTIVE: CMSPanel,
    },
    {
      NAME: 'Logout',
      INACTIVE: IconThirdPartyInactive,
    },
  ],
};

export default CONSTANTS;
